import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Group = { id: string; label: string; moduleIds: string[] };

type SidebarGroupsState = {
  groups: Group[] | undefined;
  reset: VoidFunction;
  update: (params: { groups: Group[] | undefined }) => void;
};

export const useSidebarGroupsState = create<SidebarGroupsState>()(
  persist(
    (set) => ({
      groups: undefined,
      reset: () => set({ groups: undefined }),
      update: ({ groups }: { groups: Group[] | undefined }) => set({ groups }),
    }),
    { name: 'sidebar-groups' },
  ),
);
